import { kartoyServiceImages } from '@mobile/assets/kartoy'
import { FastImage } from '@shared-ui/components/ui/fast-image'
import { View } from 'react-native'
import { useCreateStyles } from './styles'

const VISIBLE_SERVICES = [
  kartoyServiceImages.claude,
  kartoyServiceImages.chatgpt,
  kartoyServiceImages.airbnb,
  kartoyServiceImages.netflix,
]

// Перенесённый из Antarctic ряд перекрывающихся иконок сервисов.
export function ServiceIconStack() {
  const styles = useCreateStyles()

  return (
    <View style={styles.row}>
      {VISIBLE_SERVICES.map((source, index) => (
        <FastImage key={index} source={source} style={[styles.icon, index > 0 && styles.overlap]} resizeMode="cover" />
      ))}
    </View>
  )
}
